import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function VideoHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white py-20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/b8ac8bb0a9637f7d8162e441467afc93.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <Breadcrumb
          items={[
            { label: 'Home', path: '/' },
            { label: 'Videos' },
          ]}
        />

        <div className="max-w-4xl mx-auto text-center mt-8">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-video-line text-[#E8B84B]"></i>
            <span className="text-sm font-medium">No Surprises. Just the Car.</span>
          </div>

          <h1 className="font-oswald text-5xl md:text-6xl font-bold mb-6">
            See It Before{' '}
            <span className="text-[#E8B84B]">You Drive It</span>
          </h1>

          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            We film every vehicle ourselves — no stock photos, no flattering angles, no hiding the dings. 
            If it's on the lot, it's on camera. What you see is exactly what you get.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-car-line text-xl"></i>
              View Inventory
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Contact Us
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-6 mt-12">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-hd-line text-[#4ADE80] text-xl"></i>
              <span>Shot by us, not a marketing team</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-eye-line text-[#4ADE80] text-xl"></i>
              <span>The good, the bad, the honest</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-time-line text-[#4ADE80] text-xl"></i>
              <span>New videos as inventory arrives</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
